import {FileDTO} from '../../clm/models/FileDTO';
import {BaseDTO} from '../../common/models/BaseDTO';
import {NameValueDTO} from '../../common/models/NameValueDTO';
import {AddressesArrayDTO} from './AddressesArrayDTO';
import {BankAccountLinkDTO} from './BankAccountLinkDTO';
import {ContactArrayDTO} from './ContactsArrayDTO';
import {CoverStatusLinkDTO} from './CoverStatusLinkDTO';
import {InsuredPersonExclusionDTO} from './InsuredPersonExclusionDTO';
import {InsuredPersonCardHistoryDTO} from './InsuredPersonCardHistoryDTO';
import {NameValueCodeDTO} from '../../common/models/NameValueCodeDTO';
import {RemunerationDTO} from './person/RemunerationDTO';
import {PersonPolicyProductLinkDTO} from './person/PersonPolicyProductLinkDTO';
import {CoverageHistoryDTO} from './person/CoverageHistoryDTO';
import {PortalType} from '../../common/types/portal.enum';
import {PolicyProductPersonLinksDTO} from "./PolicyProductPersonLinksDTO";
import {PolicyProductVarianceLinkDTO} from "./PolicyProductVarianceLinkDTO";
import {PolicyProductWaiversLinkDTO} from "./PolicyProductWaiversLinkDTO";

export class InsuredPersonDTO extends BaseDTO {
  insuredPersonId: number;
  firstName: string;
  middleName: string;
  lastName: string;
  dateOfBirth: Date;
  sanctionCheckDate: Date;
  sanctionReference: string;
  sanctionIndicator: number;
  alternative1CardNumber: number;
  alternative2CardNumber: number;
  passportNumber: number;
  nationalIdNumber: string;
  vipIndicator: number;
  underDiseaseManagementIndicator: number;
  photo: string;
  passportCopy: string;
  cardNumber: string;
  dependentNumber: string;
  taxNumber: string;
  dateOfMarriage: Date;
  idNumberExists: boolean;
  gender: NameValueDTO;
  title: NameValueDTO;
  maritalStatus: NameValueDTO;
  association: NameValueDTO;
  designation: NameValueDTO;
  country: NameValueCodeDTO;
  associatedInsuredPerson: NameValueDTO;
  language: NameValueCodeDTO;
  ethnicity: NameValueCodeDTO;
  addresses: AddressesArrayDTO[];
  bankAccounts: BankAccountLinkDTO[];
  contacts: ContactArrayDTO[];
  coverStatuses: CoverStatusLinkDTO[];
  insuredPersonExclusions: InsuredPersonExclusionDTO[];
  insuredPersonCardHistories: InsuredPersonCardHistoryDTO[];
  policyProductPersonLinks: PersonPolicyProductLinkDTO[];
  remunerationList: RemunerationDTO[];
  coverageHistory: CoverageHistoryDTO[];
  policyProductVariances: PolicyProductVarianceLinkDTO[];
  policyProductWaivers: PolicyProductWaiversLinkDTO[];

  // Read-only fields
  status: string;
  startDate: Date;
  endDate: Date;
  policyNumber: string;
  productCode?: string;
  productName?: string;
  coverStatusName?: string;

  // FE Internal Usage
  displayValue?: string;
}
